import { render, staticRenderFns } from "./office-profiles.vue?vue&type=template&id=4a39e600&scoped=true&lang=pug"
import script from "./office-profiles.vue?vue&type=script&lang=ts"
export * from "./office-profiles.vue?vue&type=script&lang=ts"
import style0 from "./office-profiles.vue?vue&type=style&index=0&id=4a39e600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a39e600",
  null
  
)

export default component.exports